import type {
  CommonCreatedAgentEventItem,
  CommonMomentEventItem,
  CommonGameEventItem,
  CommonServiceInteractionEventItem,
} from "../types";

export const isGameEvent = (
  event: CommonMomentEventItem
): event is CommonGameEventItem => event.event_type === "game_event";

export const isServiceInteraction = (
  event: CommonMomentEventItem
): event is CommonServiceInteractionEventItem =>
  event.event_type === "service_interaction";

export const isCreatedAgent = (
  event: CommonMomentEventItem
): event is CommonCreatedAgentEventItem => event.event_type === "created_agent";
